import cleanedFilename from '~/util/cleanedFilename';

export default {
  DROPDOWN_TOGGLE: `${cleanedFilename(__filename)}-dropdown-toggle`,
  DROPDOWN_ERROR: `${cleanedFilename(__filename)}-dropdown-error`,
  DROPDOWN_LABEL: `${cleanedFilename(__filename)}-dropdown-label`,
};
